import { createFileRoute, notFound } from '@tanstack/react-router';

import TermsOfUsePage from '@/pages/terms-of-use/TermsOfUsePage';
import { getHomeHeaderButton } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import { getTermsOfUse } from '@/sanity/terms-of-use';
import { buildPageMeta } from '@/utils/seo';
import { termsOfUsePath } from '@/utils/terms-of-use';

const termsTitle = 'Terms of use — Budgy';
const termsDescription =
  'Terms of use for Budgy and Rodeo, operated by Lightning Riders Ltd.';

export const Route = createFileRoute('/terms-of-use')({
  loader: async () => {
    const [termsOfUse, headerButton, legalLinks] = await Promise.all([
      getTermsOfUse(),
      getHomeHeaderButton(),
      getLegalLinks(),
    ]);
    if (!termsOfUse) {
      throw notFound();
    }

    return { headerButton, legalLinks, termsOfUse };
  },
  component: TermsOfUsePage,
  head: () =>
    buildPageMeta({
      title: termsTitle,
      description: termsDescription,
      path: termsOfUsePath,
    }),
});
